import React from 'react'
import { BASE_URL, SUPPORT_EMAIL } from '../../utils/consts'

const LegalInformation = () => {
	return (
		<div className='container'>
			<h1 className='text-xl md:text-2xl'>Лицензионное соглашение</h1>

			<p className='mt-5'>
				Настоящий документ в соответствии со ст. 434, 438 Гражданского кодекса РФ является
				офертой (предложением) Общества с ограниченной ответственностью «ГИР СТОР» заключить
				лицензионный договор (далее – Соглашение) на использование Сайта{' '}
				<a className='link' href={BASE_URL}>
					{BASE_URL}
				</a>{' '}
				на условиях, изложенных в настоящем документе. Настоящее Соглашение содержит все
				существенные условия лицензионного договора и является договором присоединения в
				смысле ст. 428 ГК РФ. Настоящее соглашение предоставляет возможность пользователям
				самостоятельно получать, размещать на Сайте (Платформе) информацию, редактировать
				ее, удалять, хранить и выполнять с ней иные разрешенные Соглашением действия. До
				начала использования Платформы{' '}
				<a className='link' href={BASE_URL}>
					{BASE_URL}
				</a>{' '}
				и размещенных на ней данных других пользователей Лицензиат гарантирует, что: — он
				заключает настоящее соглашение добровольно, при этом Лицензиат полностью ознакомился
				с его условиями, понимает их значение и последствия своих действий; — он обладает
				всеми правами и полномочиями, необходимыми для заключения и исполнения настоящего
				соглашения; — размещаемые им на Платформе действия не нарушают и не влекут за собой
				нарушение действующего законодательства РФ и/или прав третьих лиц. Настоящее
				соглашение заключается в дополнение к Правилам размещения объявлений и Правилам для
				покупателей, опубликованным на сайте, и регулирует только те отношения, которые
				возникают между Лицензиаром и Лицензиатом при использовании последним сайта{' '}
				<a className='link' href={BASE_URL}>
					{BASE_URL}
				</a>{' '}
				(далее – Сайт, Платформа).
			</p>

			<p className='mt-10'>1. Термины и определения</p>

			<ul>
				<li>
					1. Сайт, Платформа — объект интеллектуальной собственности, представляющий собой
					совокупность программ ЭВМ, веб-страниц, баз данных, фото и видео, графических и
					текстовых элементов, находящийся на сервере Лицензиара и доступный для
					использования по адресу{' '}
					<a className='link' href={BASE_URL}>
						{BASE_URL}
					</a>
					.
				</li>
				<li>
					2. Лицензиар — Общество с ограниченной ответственностью «ГИР СТОР» (ООО «ГИР
					СТОР»), являющееся владельцем Сайта и правообладателем исключительных прав на
					него.
				</li>
				<li>
					3. Лицензиат — пользователь Платформы – любое физическое дееспособное лицо,
					достигшее возраста 18 лет, юридическое лицо или индивидуальный предприниматель.
				</li>
				<li>
					4. Объявление — размещенные на Платформе данные о продаваемых Лицензиатом
					запасных частях/комплектующих к автомобилям, их технических и иных
					характеристиках, а также о продавце.
				</li>
				<li>
					5. Учетная запись Лицензиата (личный кабинет) — совокупность данных о Лицензиате
					(id, телефон, пароль и т.п.), объединенных с пользовательским интерфейсом,
					балансом личного кабинета, историей использования Платформы и платежным
					инструментом. Доступ к личному кабинету осуществляется по логину и паролю.
				</li>
				<li>
					6. Баланс личного кабинета — регистр учета остатка денежных средств Лицензиата,
					находящихся на личном счете Лицензиара и доступных для оплаты услуг.
				</li>
			</ul>

			<h2 className='mt-5 text-xl font-bold'>2. Предмет Соглашения</h2>
			<ul className='mt-3'>
				<li>
					2.1. Лицензиар посредством предоставления права использования Платформы
					оказывает Лицензиату услуги по осуществлению доступа к информации, размещенной
					на Платформе, а также доступа к размещению объявлений на Платформе и их
					продвижению (если применимо).
				</li>
				<li>
					2.2. Для возможности оказания указанных услуг Лицензиар предоставляет Лицензиату
					неисключительную (простую) лицензию на использование Платформы (далее –
					Лицензия).
				</li>
				<li>
					2.3. Регистрируя учетную запись на Платформе, Лицензиат заключает настоящее
					соглашение и безоговорочно соглашается со всеми условиями настоящего соглашения.
				</li>
				<li>
					2.4. При использовании Платформы Лицензиат руководствуется настоящим
					соглашением, правилами и требованиями, опубликованными на Платформе и
					действующим законодательством РФ.
				</li>
				<li>
					2.5. Использование Платформы разрешается только на условиях настоящего
					соглашения. Если Лицензиат не принимает условия Соглашения в полном объёме, он
					не имеет права использовать Платформу в каких-либо целях. Использование
					Платформы с нарушением (невыполнением) какого-либо из условий Соглашения
					запрещено.
				</li>
			</ul>

			<h2 className='mt-5 text-xl font-bold'>3. Порядок предоставления прав</h2>

			<ul className='mt-3'>
				<li>
					3.1 Для заключения настоящего соглашения и использования Платформы Лицензиат
					проходит процедуру регистрации.
				</li>
				<li>
					3.2 Регистрация Лицензиата является добровольной и бесплатной. Лицензиат
					гарантирует Лицензиару, что он достиг возраста, допустимого в соответствии с
					законодательством Российской Федерации для акцепта настоящего соглашения.
				</li>
				<li>
					3.3. Для завершения регистрации Лицензиар отправляет на указанный Лицензиатом
					телефон сообщение с паролем для первой авторизации в личном кабинете. Чтобы
					завершить регистрацию, Лицензиату необходимо ввести этот пароль на Сайте.
					Лицензиар присваивает Лицензиату id (порядковый номер кабинета).
				</li>

				<li>
					3.4. Дальнейшая идентификация Лицензиата всегда проходит по связке логин-пароль,
					которые являются аналогом собственноручной подписи.
				</li>
				<li>
					3.5. Все действия с Платформой, выполненные из учетной записи Лицензиата после
					ввода логина и пароля, считаются действиями Лицензиата.
				</li>
				<li>
					3.6. Лицензиату не разрешено вмешиваться в работу программных средств Лицензиара
					каким-либо образом и/или использовать для доступа к Платформе сторонние
					программы.
				</li>
				<li>
					3.7. При соблюдении Лицензиатом условий настоящего соглашения срок действия
					Лицензии не ограничен.
				</li>
				<li>
					3.8. Лицензиату предоставляется право круглосуточно получать доступ к Платформе,
					за исключением времени профилактических работ.
				</li>
				<li>
					3.9. Лицензиат вправе использовать Платформу способами, описанными в настоящей
					Лицензии, на всей территории Российской Федерации.
				</li>
				<li>
					3.10. Лицензиат не вправе изменять и/или удалять наименование Платформы, знак
					охраны авторского права или иные указания на Лицензиара.
				</li>
				<li>
					3.11. Лицензиат не вправе использовать информацию, ставшую ему известной в
					результате использования Платформы, в каких-либо иных целях, кроме как для целей
					заключения и исполнения сделок в отношении представленных товаров.
				</li>
			</ul>

			<h2 className='mt-5 text-xl font-bold'>
				4. Лицензионное вознаграждение и стоимость услуг
			</h2>
			<ul className='mt-3'>
				<li>
					4.1. Предоставление неисключительной лицензии в рамках настоящего соглашения
					осуществляется без взимания лицензионного вознаграждения.
				</li>
				<li>
					4.2. Лицензиар вправе запрашивать оплату за оказание услуг по размещению,
					продвижению объявлений и осуществлению доступа к объявлениям, размещаемым с
					помощью Платформы.
				</li>
				<li>
					4.3. Стоимость услуг, оказываемых Лицензиату Лицензиаром с помощью Платформы,
					может зависеть от разных факторов, включая, но не ограничиваясь, такие, как
					количество размещаемых Лицензиатом объявлений, стоимость запасных частей, срок,
					на который размещается объявление, количество операций по объявлениям и др.
				</li>
				<li>
					4.4. Конечная стоимость услуги и условия ее оказания показываются Лицензиату в
					пользовательском интерфейсе личного кабинета на этапе покупки услуги. Производя
					оплату, Лицензиат безоговорочно соглашается с предложенной стоимостью и
					условиями оказания услуг.
				</li>
				<li>4.5. Оплата услуг производится Лицензиатом в порядке предоплаты.</li>
				<li>
					4.6. Оплата услуг производится Лицензиатом в безналичном порядке, либо путём
					зачисления денежных средств на счет в личный кабинет, либо другими способами,
					доступными на Сайте.
				</li>
				<li>
					4.7. Зачисленные на баланс денежные средства отображаются в пользовательском
					интерфейсе личного кабинета и учитываются для целей оплаты услуг.
				</li>
				<li>
					4.8. Услуга считается оплаченной с момента списания денежных средств с баланса
					личного кабинета Лицензиата.
				</li>
			</ul>

			<h2 className='mt-5 text-xl font-bold'>5. Права и обязанности сторон</h2>
			<ul className='mt-3'>
				<li>
					5.1. <strong>Лицензиар обязуется:</strong>
				</li>
				<li>
					<br />
					5.1.1. Предоставить Лицензиату возможность реализации прав использования
					Платформы в соответствии с условиями настоящей Лицензии.
					<br />
					5.1.2. Поддерживать работоспособность Сайта (Платформы) и личного кабинета в
					течение всего срока действия Соглашения.
					<br />
					5.1.3. За свой счет устранить неполадки в работе Сайта (Платформы) и личного
					кабинета при обнаружении таковых так быстро, как это возможно.
					<br />
					5.1.4. Предоставлять доступ в личный кабинет Лицензиата только по связке
					логин-пароль.
					<br />
					5.1.5. При поступлении оплаты за услугу оказать ее в точном соответствии с
					оплаченным счетом.
				</li>
				<li>
					<strong>5.2. Лицензиар имеет право:</strong>
				</li>
				<li>
					<br />
					5.2.1. Вносить изменения в работу Платформы, а также в условия настоящего
					соглашения без предварительного уведомления Лицензиата в течение всего срока
					действия Соглашения.
					<br />
					5.2.2. Удалять, отклонять объявления Лицензиата, если они противоречат правилам
					пользования Платформой и/или законодательству РФ, а также если объявления
					нарушают права третьих лиц.
					<br />
					5.2.3. В одностороннем порядке вносить изменения в срок предоставления права
					использования Платформы и стоимость услуг.
					<br />
					5.2.4. Прекратить право Лицензиата использовать Платформу и прекратить Лицензию
					в следующих случаях:
					<br />- истечения срока использования Платформы;
					<br />- досрочного самостоятельного прекращения Лицензиатом использования
					Платформы;
					<br />- нарушения Лицензиатом условий настоящей Лицензии, в том числе принятых
					на себя Лицензиатом гарантий, и/или правил пользования Платформой.
					<br />
					5.2.5. Безвозмездно и бессрочно использовать любым законным способом объявления,
					размещенные Лицензиатом на Платформе, для целей исполнения настоящей Лицензии.
				</li>
				<li>
					<strong>5.3. Лицензиат обязуется:</strong>
				</li>
				<li>
					<br />
					5.3.1. Действовать добросовестно, соблюдая правила, нормы действующего
					законодательства Российской Федерации при пользовании Платформой.
					<br />
					5.3.2. Следить за сохранностью связки логин-пароль и не передавать её в
					пользование третьим лицам.
					<br />
					5.3.3. Использовать Платформу в пределах прав, предоставленных Лицензией.
					<br />
					5.3.4. При работе с Платформой точно следовать подсказкам пользовательского
					интерфейса.
					<br />
					5.3.5. Своевременно оплачивать услуги, являющиеся платными.
					<br />
					5.3.6. Не передавать полученные по настоящей Лицензии права использования
					Платформы какому-либо третьему лицу без предварительного письменного согласия
					Лицензиара.
					<br />
					5.3.7. Не размещать информацию, противоречащую нормам законодательства
					Российской Федерации, в том числе, но не исключительно: побуждающую к ненависти,
					вражде, нарушающую права и законные интересы третьих лиц. За нарушение
					настоящего пункта Лицензиат самостоятельно несет ответственность,
					предусмотренную нормами гражданского, административного и уголовного
					законодательства Российской Федерации, а также возмещает все убытки Лицензиару,
					возникшие в результате нарушения Лицензиатом настоящего пункта.
					<br />
					5.3.8. Лицензиат не вправе копировать, осуществлять извлечение, сбор,
					переработку, перепечатку и/или последующее распространение информации,
					размещенной на Платформе другими Лицензиатами. За нарушение настоящего пункта
					наступает ответственность, предусмотренная нормами гражданского,
					административного и уголовного законодательства Российской Федерации, а также
					нормами международного права по охране интеллектуальной собственности.
				</li>
				<li>
					<strong>5.4. Лицензиат имеет право:</strong>
				</li>
				<li>
					<br />
					5.4.1. Следить за состоянием баланса личного кабинета и при необходимости
					пополнять его.
					<br />
					5.4.2. Обращаться к Лицензиару в случае вопросов и возражений.
				</li>
			</ul>

			<h2 className='mt-5 text-xl font-bold'>6. Ответственность сторон</h2>
			<ul className='mt-3'>
				<li>
					6.1.1. За невыполнение или ненадлежащее выполнение обязательств по настоящему
					соглашению стороны несут ответственность в соответствии с действующим
					законодательством.
				</li>
				<li>
					6.1.2. Использование Платформы способом, не предусмотренным настоящим
					соглашением либо по прекращении действия Соглашения, либо иным образом за
					пределами предоставленных прав, влечет ответственность за нарушение
					исключительного права на результат интеллектуальной деятельности, установленную
					законодательством РФ.
				</li>
				<li>
					6.2. Ни при каких обстоятельствах Лицензиар не несет ответственности за любую
					потерю, расходы, убытки или ущерб, (потеря деловых доходов, потеря прибыли или
					любой прямой, косвенный, последующий, специальный или подобный ущерб вообще),
					являющийся результатом:
					<br /> - сбоя в работе Платформы;
					<br /> - использования информации пользователей, хранящейся на Платформе;
					<br /> - любой погрешности, содержащейся в информации, хранящейся на Платформе.
				</li>
				<li>
					6.3. Лицензиат несет ответственность перед Лицензиаром и третьими лицами за
					причиненный ущерб, вследствие совершения противоправных, противоречащих
					законодательству Российской Федерации действий и действий, запрещенных настоящим
					соглашением, правилами пользования Платформой, совершенных через его личный
					кабинет.
				</li>
				<li>
					6.4. Лицензиат несет полную ответственность за сохранность своих логина и пароля
					для доступа к своей учетной записи и за убытки, которые могут возникнуть по
					причине несанкционированного использования его логина и пароля.
				</li>
				<li>
					6.5. Лицензиат несет ответственность:
					<br /> - за содержание объявлений, размещенных для общего доступа на Платформе
					или переданные в частном порядке в связи с настоящим соглашением;
					<br /> - за соблюдение всех требований законодательства, в том числе
					законодательства об интеллектуальной собственности, о конкуренции, но не
					ограничиваясь перечисленным, в отношении содержания и формы объявлений, иные
					действия, осуществляемые им в рамках Лицензии;
					<br /> - за достоверность сведений, указанных им при регистрации в качестве
					пользователя Платформы, а также иных предоставляемых им сведений и за
					достоверность гарантий и заверений его как пользователя, содержащихся в
					настоящей Лицензии.
				</li>
				<li>
					6.6. Если размещение информации Лицензиатом явилось основанием для предъявления
					к Лицензиару претензий, исков третьих лиц и/или предписаний по уплате штрафных
					санкций со стороны государственных органов в связи с нарушением прав третьих лиц
					и/или действующего законодательства, Лицензиат обязуется незамедлительно по
					требованию Лицензиара предоставить ему всю запрашиваемую информацию, касающуюся
					размещения и содержания публикаций, содействовать Лицензиару в урегулировании
					таких претензий и исков, а также возместить все убытки, причиненные Лицензиару
					вследствие предъявления ему таких претензий, исков, предписаний.
				</li>
				<li>
					6.7. Стороны не несут ответственности при невозможности выполнения своих
					обязательств в случае возникновения форс-мажорных обстоятельств. Сторона, у
					которой возникли такие обстоятельства, должна в течение трех календарных дней
					доступным ей способом оповестить о таких обстоятельствах другую сторону.
				</li>
				<li>
					6.8. Все вопросы и претензии Лицензиата, связанные с
					использованием/невозможностью использования Платформы, а также возможным
					нарушением законодательства и/или прав третьих лиц, должны направляться через
					форму обратной связи на Платформе.
				</li>
			</ul>

			<h2 className='mt-5 text-xl font-bold'>7. Прочие условия</h2>
			<ul className='mt-3'>
				<li>
					7.1. Платформа (Сайт) является объектом исключительных прав, принадлежащих
					Лицензиару, все права на Платформу защищены.
				</li>
				<li>
					7.2. Любое использование Платформы, кроме разрешенного в настоящем соглашении,
					без предварительного письменного разрешения Лицензиара запрещено.
				</li>
				<li>
					7.3. Настоящее соглашение действует с момента принятия его условий Лицензиатом
					до расторжения или прекращения в соответствии с условиями Соглашения.
				</li>
				<li>
					7.4. Соглашение может быть расторгнуто:
					<br /> - по инициативе любой из сторон в случае нарушения другой стороной
					условий Лицензии с письменным уведомлением другой стороны за 30 (тридцать)
					календарных дней до даты расторжения;
					<br /> - по инициативе Лицензиара в одностороннем внесудебном порядке в любое
					время без объяснения причин с уведомлением Лицензиата по электронной почте за 1
					(один) календарный день до даты расторжения;
					<br /> - по инициативе Лицензиара в одностороннем внесудебном порядке в случаях
					нарушения Лицензиатом обязательств и/или гарантий, принятых в соответствии с
					Соглашением и с правилами пользования Платформой.
				</li>
				<li>
					7.5. Любые споры и разногласия по настоящему соглашению подлежат урегулированию
					путем переговоров. При недостижении согласия в ходе переговоров споры и
					разногласия будут разрешаться в соответствии с действующим законодательством по
					месту нахождения Лицензиара, учитывая предварительный претензионный порядок.
					Срок рассмотрения претензии сторонами - 14 календарных дней с момента получения.
				</li>
				<li>
					7.6. Лицензиар оставляет за собой право в любой момент изменить либо дополнить
					условия настоящего соглашения, а Лицензиат соглашается с этим правом. Изменения
					и дополнения к настоящему соглашению вступают в силу после опубликования их на
					Платформе. Лицензиат вправе отвергнуть такие изменения либо дополнения, что
					означает отказ Лицензиата от исполнения Соглашения и использования Платформы.
				</li>
			</ul>

			<p className='mt-3'>
				«18» апреля 2025 г. Юридический адрес и реквизиты владельца и правообладателя
				Платформы ООО «ГИР СТОР»
				<br />
				Юридический адрес: 601443, Владимирская область, Вязниковский р-н, г Вязники,
				<br />
				ул. Ленина, стр. 46
				<br />
				ИНН 3300013334
				<br />
				ОГРН 1243300005079
				<br />
				<br />
				Адрес электронной почты:{' '}
				<a className='link' href={`mailto:${SUPPORT_EMAIL}`}>
					{SUPPORT_EMAIL}
				</a>
			</p>
		</div>
	)
}

export default LegalInformation
